import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
  }
}
